<template>
  <v-container class="mt-4 ml-2" fluid>
    <v-row>
      <v-col cols="12">
        <v-card class="shadowCard">
          <v-card-title primary-title>
            <span class="text-subtitle-1">Articulos</span>
            <v-spacer></v-spacer>

            <v-btn
              class="mr-2"
              small dark color="green"
              @click="exportExcel( articulos  , 'articulos_ERP')"
              tile
            >
              <v-icon small>mdi-microsoft-excel</v-icon>
            </v-btn>

            <v-btn
              color="orange"
              dark
              class="mr-2"
              @click="dialog = true"
              small
              tile
            >
              <v-icon small>mdi-plus</v-icon>
            </v-btn>

            <v-btn
              color="primary"
              dark
              class="text-capitalize"
              @click="initialize()"
              small
              tile
            >
              <v-icon small>mdi-refresh</v-icon>
            </v-btn>

          </v-card-title>
          <v-card-text>
            <v-row justify="end">
              <v-col cols="12" md="4" lg="3">
                <v-text-field
                  name="name"
                  label="Buscar"
                  id="id"
                  filled
                  dense
                  hide-details
                  append-icon="mdi-magnify"
                  v-model="search"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <v-data-table
                  :headers="headers"
                  :items="articulos"
                  class="elevation-0"
                  :search="search"
                  :mobile-breakpoint="100"
                  dense
                >
                  <!-- Valores que ocupan botons, chips, iconos, etc -->
                  <template v-slot:item.activo_sn="{ item }">
                    <v-chip
                      v-if="item.activo_sn == 1"
                      small
                      color="green"
                      dark
                    >Si</v-chip>

                    <v-chip
                      v-else
                      small
                      color="error"
                      dark
                    >No</v-chip>
                  </template>

                  <template v-slot:item.foto="{ item }">
                    <v-img :src="url + item.foto" aspect-ratio="2" contain/>
                  </template>

                  <template v-slot:item.actions="{ item }">
                    <v-btn
                      color="grey"
                      x-small
                      @click="editItem(item)"
                      class="mr-2"
                      icon
                    >
                      <v-icon small>mdi-pencil</v-icon>
                    </v-btn>

                    <v-btn
                      color="error"
                      x-small
                      @click="deleteItem(item)"
                      class="mr-2"
                      icon
                    >
                      <v-icon small> mdi-delete</v-icon>
                    </v-btn>
                  </template>

                  <template v-slot:no-data>
                    <v-btn
                      color="primary"
                      @click="initialize"
                      small
                    >
                      Actualizar
                    </v-btn>
                  </template>

                </v-data-table>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <!-- Dialogo de editar o agregar-->
    <v-dialog
      v-model="dialog"
      max-width="600px"
      persistent
    >
      <v-card>
        <v-card-title>
          <span class="text-subtitle-1">{{ formTitle }}</span>
          <v-spacer></v-spacer>
          <span class="text-subtitle-1">
            <strong>ID: {{ editedItem.idarticulos }}</strong>
          </span>
        </v-card-title>

        <v-card-text>
          <v-row>
            <v-col cols="12">
              <v-text-field
                v-model="editedItem.articulo"
                label="* Artículo"
                filled
                hide-details
                dense
              ></v-text-field>
            </v-col>

            <v-col cols="12">
              <v-text-field
                v-model="editedItem.precio"
                label="Precio"
                filled
                hide-details
                dense
                type="number"
              ></v-text-field>
            </v-col>

            <v-col cols="12" >
              <v-textarea
                v-model="editedItem.detalles"
                label="Detalles"
                filled
                hide-details
                auto-grow
                :rows="3"
              ></v-textarea>
            </v-col>

            <v-col cols="12">
              <label>Foto actual</label>
              <v-row>
                <v-col cols="12" md="6">
                  <v-card class="py-4 shadowCard">
                    <v-img :src="url + editedItem.foto " contain aspect-ratio="2"></v-img>
                  </v-card>
                </v-col>
              </v-row>
            </v-col>


            <v-col cols="12">
              <v-file-input
                filled
                v-model="files"
                accept="image/png, image/jpeg, image/bmp"
                placeholder="Selecciona tus imagenes" prepend-icon="mdi-camera" label="Evidencias" @change="cargarFotos()">
              </v-file-input>

              <v-row v-if="vistaPrevias.length">
                <v-col cols="12" md="6" v-for="(img, i) in vistaPrevias" :key="i">
                  <v-card class="py-4 shadowCard">
                    <v-img :src="img.url" contain aspect-ratio="2"></v-img>
                    <v-btn  color="error"  small  @click="eliminarFoto(img.url)" top right absolute fab >
                      <v-icon>mdi-delete</v-icon>
                    </v-btn>
                  </v-card>
                </v-col>
              </v-row>
            </v-col>

          </v-row>
        </v-card-text>

        <v-card-actions>
          <v-btn
            color="black"
            tile
            dark
            small
            @click="close"
          >
            <v-icon small left>mdi-cancel</v-icon>
            Cancelar
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn
            color="green darken-1"
            class=""
            tile
            dark
            small
            @click="save"
          >
            <v-icon small left>mdi-content-save</v-icon>
            Guardar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Dialogo para eliminar -->
    <v-dialog v-model="dialogDelete" max-width="500px">
      <v-card>
        <v-card-text>
          <v-row justify="space-around">
            <v-col cols="6">
              <v-card class="elevation-0" height="100%" style="display: table;">
                <div class="text-subtitle-1" style="display: table-cell; vertical-align: middle;">
                  <strong>Eliminar</strong> ¿Estás seguro que deseas eliminar la sucursal ?
                  <v-card-actions class="pt-6">
                    <!-- Cerrar dialogo de confirmación y abrir el dialogo de editar la clase -->
                    <v-btn color="error" text  class="mr-2" @click="closeDelete()">No, cancelar</v-btn>
                    <!-- Guardar la información  -->
                    <v-btn color="#5C5C5C"  dark class="elevation-6"  @click="deleteItemConfirm()">Si</v-btn>
                  </v-card-actions>
                </div>
              </v-card>
            </v-col>
            <v-col cols="5">
              <v-img src="@/assets/borrar.png"></v-img>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Dialog de carga -->
    <Alerta               v-if="respuestaAlerta"             :parametros="parametros"/>
    <carga                v-if="cargar"/>

  </v-container>
</template>
<script>
  import axios from 'axios';
  import { mapGetters } from 'vuex'
  // Componentes
  import Alerta                from '@/components/alertas/Alerta.vue'
  import carga                 from '@/components/alertas/carga.vue';

  import validarErrores        from '@/mixins/validarErrores'
  import funcionesExcel        from '@/mixins/funcionesExcel'

  export default {

    mixins: [ validarErrores, funcionesExcel ],

    components:{
      Alerta,
      carga,
    },

    data: () => ({
      // Alertas
      parametros:{
        dialogError: false,
        mensaje: '',
        color: ''
      },

      respuestaAlerta:false,
      loader: true,
      cargar: false,

      dialog: false,
      dialogDelete: false,

      editedIndex: -1,

      editedItem: {
        idarticulos:0,
        articulo:'',
        foto:'',
        detalles:'',
        deleted:null,
        fecha_creacion:null
      },

      defaultItem: {
        idarticulos:0,
        articulo:'',
        foto:'',
        detalles:'',
        deleted:null,
        fecha_creacion:null
      },

      // Filtros:
      incio:null,
      fin:null,

      url: '',

      // tabla
      search:'',
      page: 1,
      pageCount: 0,
      itemsPerPage: 10,
      articulos: [],
      headers: [
        { text: 'ID'            , value: 'idarticulos'    },
        { text: 'Artículo'      , value: 'articulo'       },
        { text: 'Foto'          , value: 'foto'           },
        { text: 'Detalles'      , value: 'detalles'       },
        { text: 'Alta'          , value: 'fecha_creacion' },
        { text: 'Actions'       , value: 'actions', sortable: false },
      ],


      files: null,
      vistaPrevias: []
    }),

    computed: {
      ...mapGetters('login',['getdatosUsuario']),
      formTitle () {
        return this.editedIndex === -1 ? 'Agregar Sucursal' : 'Editar Sucursal'
      },
    },

    watch: {
      dialog (val) {
        val || this.close()
      },
      dialogDelete (val) {
        val || this.closeDelete()
      },

    },

    async created () {

      this.url = this.$http.options.root + 'articulos-enlace/'

      await this.initialize()
    },

    methods: {
      initialize () {
        this.cargar = true
        this.articulos = []
        return this.$http.get('articulos.list').then(response=>{
          this.articulos = response.data
          this.cargar      = false
        }).catch( error =>{
          this.validarError( error )
        }).finally( () => { this.cargar = false })
      },

      editItem (item) {
        this.editedIndex = this.articulos.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialog = true
      },

      deleteItem (item) {
        this.editedIndex = this.articulos.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialogDelete = true
      },

      deleteItemConfirm () {
        this.cargar = true
        // Lo mandapos por el EP
        this.editedItem.activo_sn = 0
        this.$http.put('articulos.update/' + this.editedItem.idarticulos, this.editedItem).then(response=>{
          this.validarSuccess( response.data.message )
          this.initialize()
          this.closeDelete()
        }).catch( error =>{
        this.validarError( error )
      }).finally( () => { this.cargar = false })
      },

      close () {
        this.dialog = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },

      closeDelete () {
        this.dialogDelete = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },

      save () {

        // Creamos el documento
        let formData = new FormData();
        // agregamos el documento
        formData.append("file"       , this.files );
        formData.append("articulo"   , this.editedItem.articulo  );
        formData.append("precio"     , this.editedItem.precio    );
        formData.append("detalles"   , this.editedItem.detalles  );
        formData.append("deleted"    , this.editedItem.deleted   );
        formData.append("foto"       , this.editedItem.foto      );


        // Cargamos al usuario que hizo el cambio
        this.cargar = true

        if (this.editedIndex > -1) {
          // Lo mandapos por el EP
          this.$http.put('articulos.update/' + this.editedItem.idarticulos, formData).then(response=>{
            this.validarSuccess( response.data.message )
            this.initialize()
            this.close()
          }).catch( error =>{
            this.validarError( error )
          }).finally( () => { this.cargar = false })

        } else {
          // Lo mandapos por el EP
          this.$http.post('articulos.add', formData).then(response=>{
            this.initialize()
            this.cargar = false
            this.close()
          }).catch( error =>{
            this.validarError( error )
          }).finally( () => { this.cargar = false })
        }
      },

      cargarFotos(){
        if(!this.files){
          return
        }

        // creamos una variable tipo FormData
        let formData = new FormData();
        //se crea el objeto y se le agrega como un apendice el archivo
        formData.append('file', this.files);
        //mandamos a ocvertir la imagen a base64 pero mandamos el docuemnto, el formdata, el nombre
        this.getBase64(this.files, formData)
      },

      getBase64(file, formData) {
        var me = this
        var reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = function () {
          console.log(file)
          me.vistaPrevias.push({
            url: reader.result,
            formData: formData,
            image_name: file.name,
            file
          })
        };
      },

      eliminarFoto(value){
        this.vistaPrevias.forEach((element, index)=>{
          if(element.url == value){
            this.vistaPrevias.splice(index,1);
          }
        })
      },

    },
  }
</script>


